import * as React from "react";
const SvgFiRrHandHoldingMagic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-holding-magic_svg__a)">
      <path
        fill="#062147"
        d="M3 4.474C2.975 2.847 4.023 1.148 6.011.532c3.371-1.493 8.988.206 8.988 4.442 0 2.385-1.459 4.01-3.183 4.678-.292.113-.531-.258-.304-.473.916-.868 1.486-2 1.486-3.205 0-2-2.047-2.96-3.5-2.992-1.212-.025-3.5-.008-3.5 1.992 0 .842.906 1.5 2 1.5.583 0 1.188-.135 1.668-.466.262-.18.595.113.438.39-.451.797-1.381 1.604-3.106 1.604-3 0-3.976-1.99-4-3.527zm20.235 8.541-6.804 7.637A10 10 0 0 1 8.964 24H3.999c-2.206 0-4-1.794-4-4v-5c0-2.206 1.794-4 4-4h8.857a3.14 3.14 0 0 1 2.689 1.52l3.217-3.535a2.98 2.98 0 0 1 2.085-.98 2.97 2.97 0 0 1 2.169.781 3.02 3.02 0 0 1 .218 4.23zm-1.565-2.752a1.04 1.04 0 0 0-.728-.262 1 1 0 0 0-.699.33l-4.427 4.864a3.16 3.16 0 0 1-2.514 2.058l-5.161.737a1 1 0 0 1-.283-1.979l5.161-.737c.559-.08.98-.566.98-1.13 0-.63-.513-1.143-1.143-1.143H4c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h4.965a8 8 0 0 0 5.973-2.678l6.805-7.638a1.015 1.015 0 0 0-.072-1.42z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-holding-magic_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandHoldingMagic;
